/**
 * Converts a GraphQL __typename (PascalCase) to a human-readable format for alt text.
 * 
 * Examples:
 * - "ConfluencePage" → "Confluence Page"
 * - "JiraIssue" → "Jira Issue"
 * - "BitbucketPullRequest" → "Bitbucket Pull Request"
 * - "TownsquareGoal" → "Townsquare Goal"
 * 
 * @param typeName - The GraphQL __typename value
 * @returns Human-readable formatted string
 */
export function formatContentTypeName(typeName: string): string {
	if (!typeName) {
		return '';
	}

	let result = '';

	for (let i = 0; i < typeName.length; i++) {
		const char = typeName[i];

		// Add space before uppercase letters (except the first character)
		if (i > 0 && char === char.toUpperCase() && char !== char.toLowerCase()) {
			result += ' ';
		}

		result += char;
	}

	return result;
}
